import React from 'react';
import {
    CornerBadgeSide,
    CornerBadgeText,
    CornerBadgeWrapper
} from './HBCornerBadge.styles';

export interface HBCornerBadgeProps {
    /** Text displayed on the ribbon badge (e.g. "New!", "Sale", "Featured"). */
    content: string;
    /** Which corner of the positioned parent to anchor the ribbon. 'topRight' pins to the top-right corner; 'topLeft' pins to the top-left corner. Defaults to 'topRight'. */
    position?: HBCornerBadgePosition;
}

export type HBCornerBadgePosition = 'topRight' | 'topLeft';

export const HBCornerBadge = ({
    position = 'topRight',
    content
}: HBCornerBadgeProps) => {
    return (
        <CornerBadgeWrapper position={position}>
            <CornerBadgeSide />
            <CornerBadgeText type="emphasis12">{content}</CornerBadgeText>
        </CornerBadgeWrapper>
    );
};
